module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/icon_empty-0cc3eb012cba67f37400111c1f041a6a.svg";